import styles from './ThreeDotsAnimation.module.css'

export const ThreeDotsLoadingAnimation = () => {
  return <div className={styles['dot-flashing']}></div>
}
